import { colorForest400 } from "@amzn/meridian-tokens/base/color";

export const FooterTokens = {
  buttonBackgroundColorTertiaryDefault: "#25303E",
  buttonBackgroundColorTertiaryHover: "#0C1521",
  buttonBackgroundColorTertiaryDisabled: "#BEBEC4",
  buttonBackgroundColorTertiaryPressed: "#0C1521",
  buttonForegroundColorTertiaryDisabled: "#F0F1F2",
  buttonBorderColorTertiaryDefault: "#25303E",
  buttonBorderColorTertiaryDisabled: "#BEBEC4",
  buttonBorderColorTertiaryHover: "#0C1521",
  buttonBorderColorTertiaryPressed: "#0C1521",
  buttonForegroundColorTertiaryDefault: "#FFF",
  buttonBackgroundColorSecondaryDefault: "#E7E9E9",
  buttonBackgroundColorSecondaryHover: "#AEB5B5",
  buttonBackgroundColorSecondaryDisabled: "#ECEDED",
  buttonBackgroundColorSecondaryPressed: "#AEB5B5",
  buttonForegroundColorSecondaryDisabled: "#ABB0B5",
  buttonForegroundColorSecondaryDefault: "#CC0C39",
};

export const BreadcrumbTokens = {
  breadcrumbForegroundColorDefault: "#18A395",
  breadcrumbForegroundColorHover: "#18A395",
  breadcrumbForegroundColorSelected: "#BBC0C1",
}

export const GreenLoaderTokens = {
  loaderIndicatorBackgroundColor: colorForest400,
};

export const PrimaryGreenColorToken = {
  textColorPrimary: colorForest400,
};
